import { render, staticRenderFns } from "./ReportCenter.vue?vue&type=template&id=438fd51f&scoped=true&"
import script from "./ReportCenter.vue?vue&type=script&lang=js&"
export * from "./ReportCenter.vue?vue&type=script&lang=js&"
import style0 from "./ReportCenter.vue?vue&type=style&index=0&id=438fd51f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438fd51f",
  null
  
)

export default component.exports